

















import VueOptions from '@utils/VueOptions'
import SupplierSelector from '@ui/Supplier/SupplierSelector'

settings =
  name: 'AudiencePartnershipForm'

  vue:
    props: ['item', 'actions', 'mode']
    components: { SupplierSelector }

    computed:
      actionsForSupplierSelector: ->
        {
          select: @selectSupplier,
          unselect: @unselectSupplier,
        }

    methods:
      selectSupplier: (option) ->
        @item.supplier_id = option.key
        @actions.syncItem()
      unselectSupplier: (option) ->
        @item.supplier_id = null
        @actions.syncItem()

export default VueOptions.vue settings
